import {select as d3select} from 'd3-selection';
import * as geo from 'd3-geo';
import {geoRobinson} from 'd3-geo-projection';
import {scaleLinear} from 'd3-scale';
import {transition as d3transition} from 'd3-transition';
import * as _ from 'underscore';

import Model from '../Model/Model';
import Dispatch from '../Dispatch/Dispatch';
import State from '../State/State';

import './Map.css';

var width = 600, height = 330;
var container = d3select('#regional-map g.RegionalMap-map');

var projection = geoRobinson()
  .scale(470)
  .translate([width / 2, height / 2])
  .center([40, -30])
  .precision(.1);

var geoGenerator = geo.geoPath()
  .projection(projection);

var choroplethScale = scaleLinear().domain([0, 65]).range(['#eee', '#999']);

var orange = '#DB8A33';

var countryLabels = [
	{id: 'Burundi', label: 'Burundi', pos: [30, -3.7]},
	{id: 'Congo Democratic Republic', label: 'Congo DR', pos: [23, -3]},
	{id: 'Ethiopia', label: 'Ethiopia', pos: [39.5, 8.2]},
	{id: 'Kenya', label: 'Kenya', pos: [37.8, 0]},
	{id: 'Malawi', label: 'Malawi', pos: [34, -13.5]},
	{id: 'Mozambique', label: 'Mozambique', pos: [35.2, -18]},
	{id: 'Rwanda', label: 'Rwanda', pos: [30.2, -2.1]},
	{id: 'Tanzania', label: 'Tanzania', pos: [34.4, -6.5]},
	{id: 'Uganda', label: 'Uganda', pos: [32.9, 1.2]},
	{id: 'Zambia', label: 'Zambia', pos: [26, -15]},
	{id: 'Zimbabwe', label: 'Zimbabwe', pos: [29.4, -19.3]}
]

var transition = d3transition();

function regionFill(d) {
	if(Model.dataLU === null)
		return 'white';

	let country = d.properties['CNTRYNAMEE'];
	let region = d.properties['DHSREGEN'];
	return choroplethScale(Model.dataLU[country][region].burden)
}

function onRegionMouseover(d) {
	var countryName = d.properties['CNTRYNAMEE'];
	State.set('hoveredCountry', countryName);
}

function onRegionMouseout(d) {
	State.set('hoveredCountry', null);
}

function onRegionClick(d) {
	var countryName = d.properties['CNTRYNAMEE'];
	State.set('selectedCountry', countryName);
}

function updateRegionMap() {
	var u = container
		.select('.RegionalMap-regions')
		.selectAll('path')
		.data(Model.regionsJson.features);

	u
		.enter()
		.append('path')
		.attr('d', geoGenerator)
		.on('mouseover', onRegionMouseover)
		.on('mouseout', onRegionMouseout)
		.on('click', onRegionClick)

		.merge(u)
		.style('fill', regionFill)
		.style('stroke', 'white')

}

function updateCountryMap() {
	var u = container
		.select('.RegionalMap-countries')
		.selectAll('path')
		.data(Model.countryJson.features);

	u
		.enter()
		.append('path')
		.attr('d', geoGenerator);
}

function updateLabels() {
	var u = container
		.select('.RegionalMap-labels')
		.selectAll('text')
		.data(countryLabels);

	u
		.enter()
		.append('text')
		.text(d => d.label)
		.each(function(d) {
			var projectedPos = projection(d.pos);
			d3select(this)
				.attr('x', projectedPos[0])
				.attr('y', projectedPos[1])
		})
}

function updateHighlighted() {
	container
		.select('.RegionalMap-regions')
		.selectAll('path')
		.style('fill', d => {
			var countryName = d.properties['CNTRYNAMEE']
			return State.hoveredCountry === countryName || State.selectedCountry === countryName ? orange : regionFill(d);
		})
		.style('stroke', d => {
			var countryName = d.properties['CNTRYNAMEE']
			return State.hoveredCountry === countryName || State.selectedCountry === countryName ? orange : 'white';
		})
		.style('stroke-width', d => {
			var countryName = d.properties['CNTRYNAMEE']
			return State.hoveredCountry === countryName || State.selectedCountry === countryName ? 1 : 0.4;
		})

	container
		.select('.RegionalMap-labels')
		.selectAll('text')
		.classed('highlighted', d => State.hoveredCountry === d.id || State.selectedCountry === d.id)
}

function updatePosition() {
	container
		.interrupt()
		.transition(transition)
		.duration(1000)
		.attr('transform', State.selectedCountry === null ? 'translate(320, 260)' : 'translate(60, 260)');
}

export function init() {
	Dispatch.dispatch.on('regionBoundariesReady.Map', update)
	Dispatch.dispatch.on('countryBoundariesReady.Map', update)
	Dispatch.dispatch.on('dataReady.Map', update)
	Dispatch.dispatch.on('hoveredCountryUpdate.Map', updateHighlighted)
	Dispatch.dispatch.on('selectedCountryUpdate.Map', () => {
		updateHighlighted()
		updatePosition()
	})
}

export function update() {
	// console.log('map update', Model.data);

	if(Model.regionsJson !== null) {
		updateRegionMap()
	}

	if(Model.countryJson !== null) {
		updateCountryMap()
		updateLabels()
	}
};


/** WEBPACK FOOTER **
 ** ./src/Map/Map.js
 **/